import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Protected from "./components/Protected";
import Home from "./pages/Home";
import { SignIn, SignUp, ForgotPassword } from "./pages/Auth";
import { ArtistsList, ArtistProfile } from "./pages/Artists";
import Explore from "./pages/Explore";
import Flash from "./pages/Flash";
import Community from "./pages/Community";
import BlogIndex from "./pages/BlogIndex";
import BlogEditorPage from "./pages/BlogEditor";
import BlogPost from "./pages/BlogPost";
import { DashboardLayout, DashboardHome, ProfileEdit, PortfolioManage, BookingsManage, AftercarePage, SavedPage, MyBlogPosts } from "./pages/Dashboard";
import AdminFlags from "./pages/AdminFlags";
import { Terms } from "./pages/Legal";
import NotFound from "./pages/NotFound";
import ErrorBoundary from "./components/ErrorBoundary";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { ConsentProvider } from "./lib/consent";
import CookieConsent from "./components/CookieConsent";

function Shell({ children }) {
  const { pathname } = useLocation();
  return <ErrorBoundary resetKey={pathname}>{children}</ErrorBoundary>;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <ConsentProvider>
        <BrowserRouter>
          <NavBar/>
          <Shell>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/sign-in" element={<SignIn/>}/>
            <Route path="/sign-up" element={<SignUp/>}/>
            <Route path="/forgot-password" element={<ForgotPassword/>}/>
            <Route path="/artists" element={<ArtistsList/>}/>
            <Route path="/artists/:username" element={<ArtistProfile/>}/>
            <Route path="/explore" element={<Explore/>}/>
            <Route path="/flash" element={<Flash/>}/>
            <Route path="/community" element={<Community/>}/>
            <Route path="/blog" element={<BlogIndex/>}/>
            <Route path="/blog/new" element={<Protected><BlogEditorPage/></Protected>}/>
            <Route path="/blog/:slug" element={<BlogPost/>}/>
            <Route path="/blog/:slug/edit" element={<Protected><BlogEditorPage editMode/></Protected>}/>
            <Route path="/dashboard" element={<Protected><DashboardLayout/></Protected>}>
              <Route index element={<DashboardHome/>}/>
              <Route path="profile" element={<ProfileEdit/>}/>
              <Route path="portfolio" element={<Protected artistOnly><PortfolioManage/></Protected>}/>
              <Route path="bookings" element={<BookingsManage/>}/>
              <Route path="aftercare" element={<AftercarePage/>}/>
              <Route path="saved" element={<SavedPage/>}/>
              <Route path="blog" element={<MyBlogPosts/>}/>
            </Route>
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/admin/flags" element={<Protected adminOnly><AdminFlags/></Protected>}/>
            <Route path="/terms" element={<Terms/>}/>
            {/* <Route path="/privacy" element={<Privacy/>}/> */}
            <Route path="*" element={<NotFound/>}/>
          </Routes>
          </Shell>
          <Footer/>
          <Toaster position="top-right" closeButton toastOptions={{ style: { fontFamily: "DM Sans" } }}/>
          <CookieConsent/>
        </BrowserRouter>
        </ConsentProvider>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
